import Domen from '../../../stores/Domen';

export const EditAttributeName = async ( inputt1, inputt4 ) => {
    try {
        const token = localStorage.getItem("token");
        const attr = {
            name: inputt1,
        };

        localStorage.setItem("countactivetime", Date.now());

        const response = await fetch(`${Domen.url}portraits/attribute/${inputt4}`, {
            method: "PUT",
            headers: {
                Authorization: token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(attr),
        });

        if (response.status === 200 || response.status === 202) {
            const data = await response.json();
            location.href = location.href;
        } else {
            alert("Something went wrong, request status: " + response.status);
        }
    } catch (error) {
        console.error("editAttributenull error:", error);
    }
};
